import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { ProductsQueryPayload } from "../../../../types/taxonomy";
import { PRODUCT_IDS_QUERY } from "../queries/productIdsQuery";
import { TAXONOMY_CLIENT } from "../../../../utils/consts";

export const useGetProductsByCategoryIds = (categoryIds: Array<string>) => {
  const { data, loading: isLoading } = useQuery<ProductsQueryPayload>(
    PRODUCT_IDS_QUERY,
    {
      variables: {
        categoryIds,
      },
      skip: categoryIds.length === 0,
      context: {
        clientName: TAXONOMY_CLIENT,
      },
    }
  );

  const products = useMemo(() => data?.product.data, [data?.product.data]);

  return { products, loading: isLoading };
};
